import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "~/Core/Components/shadcn/ui/sheet";

export function Disclaimer() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <a role="button">Disclaimer</a>
      </SheetTrigger>
      <SheetContent className="top-0 max-w-[480px] bg-neutrals-pale-sand p-0  outline-none">
        <div className="grid flex-1 auto-rows-min gap-0  overflow-y-auto max-h-[100%]">
          <SheetHeader className="py-10  px-12 sticky top-0 bg-neutrals-pale-sand ">
            <SheetTitle className="!text-larg-medium text-primary-darkest-green !leading-9">Musahama’s Disclaimer</SheetTitle>
          </SheetHeader>
          <hr className="m-0" />
          <div
            className=" px-12   prose prose-p:text-small-light prose-li:text-small-light prose-p:text-secondary-dark-grey 
          prose-h2:text-secondary-darkest-grey prose-h2:text-regular-regular prose-h2:mt-9">
            <div className="component-content prose w-full max-w-full prose-2xl">
              <div className="field-content">
                <p>
                  Your access and use of the Public Investment<em>&nbsp;Fund&apos;s (&quot;</em>
                  <em>
                    <strong>Musahama</strong>
                  </em>
                  <em>&ldquo;, &ldquo;</em>
                  <em>
                    <strong>our</strong>
                  </em>
                  <em>&quot;, or &quot;</em>
                  <em>
                    <strong>we</strong>
                  </em>
                  <em>&rdquo;) website&nbsp;</em>
                  <a href="https://www.Musahama.gov.sa/">www.Musahama.gov.sa</a>
                  <em>&nbsp;(“</em>
                  <em>
                    <strong>Website</strong>
                  </em>
                  <em>&rdquo;) is subject to the following terms of use (&quot;</em>
                  <em>
                    <strong>Terms</strong>
                  </em>
                  <em>
                    &quot;), Musahama&apos;s Privacy Policy, and Disclaimer, and the laws of the Kingdom of Saudi Arabia, your consent and approval to
                    these Terms is deemed effective upon your first use of this Website. Musahama, at its sole discretion, may amend these Terms with
                    immediate effect and your consent and approval to such amendments is deemed upon your continuous use of the Website.
                  </em>
                </p>
                <h2>Use of the Website</h2>
                <p>
                  The contents of this Website are available for general information only and Musahama does not represent nor warrant the accuracy,
                  reliability, or completeness of the information provided.
                </p>
                <p>
                  By using this Website, you agree and undertake not to:
                  <br />
                </p>
                <ol>
                  <li>use the Website in any way to send spam, phishing, or unsolicited emails;</li>
                  <li>
                    use the Website in claims to offer investment, banking, or financial services, or any other services, or in requesting monetary
                    deposits or financial and/or personal information, or any fraudulent activity;
                  </li>
                  <li>use the Website, by post or publish or otherwise, in a defamatory, obscene, infringing, or disparaging way;</li>
                  <li>
                    upload files containing viruses or corrupt data, attack this Website in any way including using malicious or harmful technology,
                    or using software to interfere with the proper operation of the Website;
                  </li>
                  <li>misuse the Website to engage in activities that are illegal or unlawful in the Kingdom of Saudi Arabia;</li>
                  <li>attempt to get unauthorized access to the Website, servers or any connected databases, portals, or devices; or</li>
                  <li>create a link to this Website in any way suggesting or claiming Musahama&apos;s association, endorsement, or approval.</li>
                </ol>
                <p>
                  Any breach of these Terms, misuse or abuse of any content or material on the Website, or unauthorized access to the Website is
                  strictly prohibited and may result in claims for damages and/or criminal offenses as per the applicable laws and regulations in the
                  Kingdom of Saudi Arabia.
                  <br />
                  <br />
                </p>
                <h2>Secure Usage Policy</h2>
                <p>
                  In consideration of using the Musahama web applications, I confirm that I have read, understood and agree to comply with the below
                  statements; and I shall abide by them while using or accessing the Musahama web applications.
                  <br />
                </p>
                <ol>
                  <li>
                    I am aware that all data stored on or originating from, and all communications transmitted or received using, Musahama web
                    applications are considered the property of the Musahama.{" "}
                  </li>
                  <li>I will not copy, distribute, lose, misuse, disclosure or modify any information related to Musahama without prior approval.</li>
                  <li>
                    I will comply, and I will respect the Musahama cybersecurity policies and procedures, and law of the Kingdom of Saudi Arabia and
                    any other related regulations.
                  </li>
                  <li>
                    I will not attempt any unauthorized access to, interference with or disruption of any software, data, documents or systems
                    available through Musahama web application.
                  </li>
                  <li>
                    I will not copy or download any material or any portion protected by copyright without proper authorization from the copyright
                    owner.
                  </li>
                </ol>
                <p />

                <h2>Property Rights</h2>
                <p>
                  All intellectual property including, but not limited to, copyright in, and to, the content, trademarks, logos, trade names, design,
                  layout, overall appearance, graphics, and other proprietary information provided on, or via, this Website (whether in text, images
                  or other materials) are owned by, or have been licensed to, or have permission to use by Musahama and cannot be used without
                  Musahama&apos;s prior written approval.
                  <br />
                  <br />
                </p>
                <h2>Applicable Law</h2>
                <p>
                  These Terms, including the Privacy Policy and the Disclaimer, and your use of this Website is governed by the laws of the Kingdom of
                  Saudi Arabia and any non-contractual or contractual dispute or claim is subject to the exclusive jurisdiction of the courts in the
                  Kingdom of Saudi Arabia.
                </p>
              </div>{" "}
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
